import { UserFeatureToggles } from '@/clients/UserClient/types';

export { UserFeatureToggles };

export const userFeatureToggles = {
  dontShowQualificationQuestionaryPreview: UserFeatureToggles.RJ_COMMUNICATION_HUB_DONT_SHOW_QUESTIONNAIRE_PREVIEW,
  dontShowWhatsappMessagePreview: UserFeatureToggles.RJ_COMMUNICATION_HUB_DONT_SHOW_WHATSAPP_MESSAGE,
  autoSendInterviewInvite: UserFeatureToggles.RJ_COMMUNICATION_HUB_AUTO_SEND_INTERVIEW_INVITE,
} as const;
